import styled from 'styled-components'
// components
import { Paper as PaperOrigin, Typography } from 'components/UI'
// themes
import { colors } from 'themes'
// icons
import ShareIcon from '@mui/icons-material/MobileScreenShareRounded'

export const LicencePaper = styled(PaperOrigin)`
  && {
    width: 100%;
    padding: 20px;
  }
`

export const Title = styled(Typography)`
  && {
    font-size: 18px;
    font-weight: bold;
  }
`

export const SetLicences = styled.div`
  font-size: 14px;
  margin: 10px 10px 10px 0;
  color: ${colors.green500};
  cursor: pointer;
`

export const Share = styled(ShareIcon)`
  color: ${colors.green500};
  cursor: pointer;
`
